import { CURRENT_ENV } from '@root/core/configs/env';
import { Button, Card, Form, Input, message, Modal, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';

import forgotPassService from '@root/modules/Authentication/ForgotPass/services/forgotpass';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';

const ChangePass: React.FC = () => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const { token } = useParams<{ token: string }>();
  const [form] = Form.useForm();
  const { type } = useTypedSelector((state) => state.inventoryReducer);
  const [statusCode, setStatusCode] = useState([] as any);
  console.log(type, 'HIHI');
  const [show, setShow] = useState(false);

  const getDt = async () => {
    setLoading(true);

    try {
      const { response } = await forgotPassService.getResetToken(token);
      if (response) {
        setStatusCode(response.data.message[0]);
      }
    } catch (error: any) {
    } finally {
    }
    setLoading(false);
  };

  useEffect(() => {
    getDt();
  }, []);

  const onFinish = async (values: any) => {
    if (statusCode === 'Expried Token') {
      history.push('/admin/find-password');
    } else {
      setLoading(true);
      try {
        const body = {
          password: values?.password,
          password_confirmation: values?.confirmPass
        };
        if (type === 'forwarder-admin') {
          const response = await forgotPassService.changePassForwarder(
            token,
            body
          );
          setLoading(false);

          setShow(true);
        } else {
          const response = await forgotPassService.changePass(token, body);
          if (response.message === 'success') {
            setLoading(false);

            setShow(true);
            // Modal.success({
            //   title: 'Password change is complete.',
            //   content: 'Click OK to go to the login screen!',
            //   onOk: () => {
            //     history.push('/admin/login-warehouse');
            //   }
            // });
          }
        }
      } catch (error: any) {
        const { response } = error;
        if (response && response.data) {
          setLoading(false);

          message.error(response.data.message[0]);
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Spin spinning={loading}>
      <div className="container login-page change-pass">
        <Form
          form={form}
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          layout="vertical"
        >
          <Row justify="space-around" align="middle">
            {statusCode === 'Expried Token' ? (
              <>
                {' '}
                <div className="login-form">
                  <Card>
                    <div className="login-form__top">
                      <div className="wrapper-image">
                        <img
                          src={`${CURRENT_ENV.PREFIX_IMG}/images/logo-busk.svg`}
                          alt="logo-terafty"
                        />
                      </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      {' '}
                      <h2>The link has expired.</h2>
                      <p>
                        Click the button below to go to the Reset Password
                        screen.
                      </p>
                    </div>

                    <Button type="primary" htmlType="submit" block={true}>
                      Reset password
                    </Button>
                  </Card>
                </div>
              </>
            ) : (
              <div className="login-form">
                <Card>
                  <div className="login-form__top">
                    <div className="wrapper-image">
                      <img
                        src={`${CURRENT_ENV.PREFIX_IMG}/images/logo-busk.svg`}
                        alt="logo-terafty"
                      />
                    </div>

                    <p>Please enter the password to change.</p>
                  </div>

                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        pattern: new RegExp(
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
                        ),
                        // pattern: new RegExp(/^[A-Za-z\s][A-Za-z0-9\s]{7,}$/),
                        message: `Please check your password`
                      }
                    ]}
                  >
                    <Input.Password placeholder="At least 8 digits including Capital letter, small letter, numbers, and special character." />
                  </Form.Item>

                  <p>Confirm password</p>
                  <Form.Item
                    name="confirmPass"
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Please check your password.'
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }

                          return Promise.reject(
                            new Error('Password does not match..')
                          );
                        }
                      })
                    ]}
                  >
                    <Input.Password
                      className="border-input"
                      placeholder="Please enter the password again"
                    />
                  </Form.Item>
                  <Button type="primary" htmlType="submit" block={true}>
                    Confirm
                  </Button>
                </Card>
              </div>
            )}
          </Row>
        </Form>
        <Modal
          width={400}
          visible={show}
          onOk={() => {
            setShow(false);
            localStorage.clear();
            if (type === 'forwarder-admin') {
              history.push('/admin/login-forwarder');
            } else {
              history.push('/admin/login-warehouse');
            }
          }}
          cancelButtonProps={{ style: { display: 'none' } }}
          onCancel={() => {
            setShow(false);
          }}
          okButtonProps={{
            style: {
              padding: '.5rem 2.5rem',
              height: 'auto',
              border: 'none',
              borderRadius: '7.25px',
              backgroundColor: '#2B2C51',
              display: 'inline-block'
            }
          }}
          okText="OK"
          maskClosable={true}
        >
          {' '}
          <div>
            <strong>Password change is complete.</strong>
          </div>
          <div style={{ textAlign: 'center' }}>
            Click OK to go to the login screen!
          </div>
        </Modal>
      </div>
    </Spin>
  );
};

export default ChangePass;
